export const OPTIONAL_ORIGIN_CREATE = 'character.OPTIONAL_ORIGIN_CREATE';
export const OPTIONAL_ORIGIN_ADD = 'character.OPTIONAL_ORIGIN_ADD';
export const OPTIONAL_ORIGIN_ADD_COMMIT = 'character.OPTIONAL_ORIGIN_ADD_COMMIT';
export const OPTIONAL_ORIGIN_SET_REQUEST = 'character.OPTIONAL_ORIGIN_SET_REQUEST';
export const OPTIONAL_ORIGIN_SET = 'character.OPTIONAL_ORIGIN_SET';
export const OPTIONAL_ORIGIN_SET_COMMIT = 'character.OPTIONAL_ORIGIN_SET_COMMIT';
export const OPTIONAL_ORIGIN_DESTROY = 'character.OPTIONAL_ORIGIN_DESTROY';
export const OPTIONAL_ORIGIN_REMOVE = 'character.OPTIONAL_ORIGIN_REMOVE';
export const OPTIONAL_ORIGIN_REMOVE_COMMIT = 'character.OPTIONAL_ORIGIN_REMOVE_COMMIT';
